import { render } from "./OrganizationPage.vue?vue&type=template&id=2cd65303&ts=true"
import script from "./OrganizationPage.vue?vue&type=script&lang=ts"
export * from "./OrganizationPage.vue?vue&type=script&lang=ts"

import "./OrganizationPage.vue?vue&type=style&index=0&id=2cd65303&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__